<form [formGroup]="form">
  @if (isDateInputSupported) {
    <div [style.--margin-bottom]="marginBottom">
      <input
        id="{{ dateFieldParameters.nativeInputId }}"
        [name]="$formFields.nativeInputDate"
        class="form-element"
        [formControlName]="$formFields.nativeInputDate"
        type="date"
        [max]="nativeMaxValue()"
        [min]="nativeMinValue()"
        [attr.required]="required ? '' : null"
        [attr.aria-describedby]="errorFieldId || null"
        [style.--width]="dateFieldParameters.width"
      />
    </div>
  } @else {
    <div class="row custom-date-field" [style.--margin-bottom]="marginBottom">
      <div class="col-md-12 col-12">
        <label for="{{ formId }}_{{ $dateParts.day }}">{{ 'time_day' | translate }}:</label>
        <select id="{{ formId }}_{{ $dateParts.day }}" [name]="$dateParts.day" [formControlName]="$dateParts.day">
          <option [ngValue]="null">{{ 'select_day' | translate }}</option>
          @for (availableDay of availableDays; track $index) {
            <option [ngValue]="availableDay">{{ availableDay }}</option>
          }
        </select>
        <label for="{{ formId }}_{{ $dateParts.month }}">{{ 'time_month' | translate }}:</label>
        <select id="{{ formId }}_{{ $dateParts.month }}" [name]="$dateParts.month" [formControlName]="$dateParts.month">
          <option [ngValue]="null">{{ 'select_month' | translate }}</option>
          <option [ngValue]="0">{{ 'month_january' | translate }}</option>
          <option [ngValue]="1">{{ 'month_february' | translate }}</option>
          <option [ngValue]="2">{{ 'month_march' | translate }}</option>
          <option [ngValue]="3">{{ 'month_april' | translate }}</option>
          <option [ngValue]="4">{{ 'month_may' | translate }}</option>
          <option [ngValue]="5">{{ 'month_june' | translate }}</option>
          <option [ngValue]="6">{{ 'month_july' | translate }}</option>
          <option [ngValue]="7">{{ 'month_august' | translate }}</option>
          <option [ngValue]="8">{{ 'month_september' | translate }}</option>
          <option [ngValue]="9">{{ 'month_october' | translate }}</option>
          <option [ngValue]="10">{{ 'month_november' | translate }}</option>
          <option [ngValue]="11">{{ 'month_december' | translate }}</option>
        </select>
        <label for="{{ formId }}_{{ $dateParts.year }}">{{ 'time_year' | translate }}:</label>
        <select id="{{ formId }}_{{ $dateParts.year }}" name="{{ $dateParts.year }}" formControlName="{{ $dateParts.year }}">
          <option [ngValue]="null">{{ 'select_year' | translate }}</option>
          @for (availableYear of availableYears; track $index) {
            <option [ngValue]="availableYear">{{ availableYear }}</option>
          }
        </select>
      </div>
    </div>
  }
</form>
